module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "printer-content",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac0f3946"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/util/Printer.vue
// module id = 105
// module chunks = 0